import { createFileRoute } from "@tanstack/react-router";

import { SKUStoreBrandMappingPage } from "@/features/SKUStore/SKUStoreBrandMappingPage";

export const Route = createFileRoute("/_auth/sku-store/$siteId/mapping")({
  component: SKUStoreBrandMappingPage,
});
